import { render, staticRenderFns } from "./ChannelsTagsDisplay.vue?vue&type=template&id=4a9a589d"
import script from "./ChannelsTagsDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChannelsTagsDisplay.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports